var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.868 63.4079V150.46C204.868 180.509 180.509 204.868 150.46 204.868H63.4079C33.3593 204.868 9 180.509 9 150.46V63.4079C9 33.3593 33.3593 9 63.4079 9H150.46C180.509 9 204.868 33.3593 204.868 63.4079Z",
    stroke: "black",
    strokeWidth: 16.3224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3621 105.042C102.949 105.042 102.949 150.46 75.3621 150.46C59.8004 150.46 41.6445 150.46 41.6445 150.46V105.042M75.3621 105.042C59.8004 105.042 41.6445 105.042 41.6445 105.042M75.3621 105.042C102.949 105.042 102.949 63.4078 75.3621 63.4078C63.1011 63.4078 41.6445 63.4078 41.6445 63.4078V105.042",
    stroke: "black",
    strokeWidth: 16.3224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.02 96.0526C129.996 96.0526 117.816 108.232 117.816 123.257H172.224C172.224 108.232 160.044 96.0526 145.02 96.0526Z",
    stroke: "black",
    strokeWidth: 16.3224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.816 123.256C117.816 138.281 129.996 150.46 145.02 150.46C155.114 150.46 161.239 146.952 164.744 143.716",
    stroke: "black",
    strokeWidth: 16.3224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.342 68.8486H128.697",
    stroke: "black",
    strokeWidth: 16.3224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.78ef8e52cc1215105b2691cc3449fc75.svg";
export { ForwardRef as ReactComponent };